(()=>{
  const params=new URLSearchParams(location.search);
  const allowed=['rosa','safra','salvia','coral','personalizado'];
  const selected=params.get('acabado');
  const attribution=['utm_source','utm_medium','utm_campaign','utm_content'];
  document.querySelectorAll('a[href]').forEach(link=>{
    const destination=new URL(link.href,location.href);
    if(destination.origin!==location.origin||!/(personaliza-tu-fallera|coleccion)/.test(destination.pathname))return;
    attribution.forEach(key=>{const value=params.get(key);if(value)destination.searchParams.set(key,value.slice(0,128));});
    link.href=destination.href;
  });
  document.querySelectorAll('[data-tf-acabado]').forEach(select=>{if(allowed.includes(selected))select.value=selected;});
  document.querySelectorAll('[data-tf-utm]').forEach(input=>{input.value=(params.get(input.dataset.tfUtm)||'').slice(0,128);});
  document.querySelectorAll('.tf-form').forEach(form=>{
    const panels=[...form.querySelectorAll('[data-tf-panel]')];
    if(!panels.length)return;
    let step=0;
    const occasions={mayor:'Fallera Mayor',infantil:'Fallera Mayor Infantil',amiga:'Amiga o familiar'};
    const occasion=occasions[params.get('ocasion')];
    if(occasion){const radio=[...form.querySelectorAll('input[type=radio]')].find(x=>x.value===occasion);if(radio)radio.checked=true;}
    const update=()=>{
      panels.forEach((panel,index)=>panel.hidden=index!==step);
      form.querySelectorAll('[data-tf-progress]').forEach((item,index)=>{if(index===step)item.setAttribute('aria-current','step');else item.removeAttribute('aria-current');});
      const recipient=form.querySelector('input[type=radio]:checked')?.value;
      const finish=form.querySelector('[data-tf-acabado]');
      const recap=form.querySelector('[data-tf-recap]');
      if(recap)recap.textContent=recipient?`${recipient} · ${finish.selectedOptions[0].textContent}`:'';
    };
    const next=()=>{
      const invalid=[...panels[step].querySelectorAll('input,select,textarea')].find(input=>!input.checkValidity());
      if(invalid){invalid.reportValidity();return;}
      step=Math.min(step+1,panels.length-1);update();panels[step].querySelector('input,textarea,select')?.focus();
    };
    form.classList.add('tf-enhanced');update();
    form.querySelectorAll('[data-tf-next]').forEach(button=>button.addEventListener('click',next));
    form.querySelectorAll('[data-tf-back]').forEach(button=>button.addEventListener('click',()=>{step=Math.max(0,step-1);update();panels[step].querySelector('input,select,textarea')?.focus();}));
    form.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.tagName==='INPUT'&&step<2){event.preventDefault();next();}});
    form.addEventListener('invalid',event=>{const panel=event.target.closest('[data-tf-panel]');if(panel&&panel.hidden){step=panels.indexOf(panel);update();}},true);
    const finish=form.querySelector('[data-tf-acabado]');
    const refreshImage=()=>{
      const template=document.querySelector(`template[data-tf-image="${finish.value}"]`);
      const source=template?.content.querySelector('img');
      const visual=document.querySelector('.tf-form-intro figure img');
      if(source&&visual){visual.src=source.getAttribute('src');visual.alt=source.alt;}
      const caption=document.querySelector('[data-tf-preview-caption]');
      if(caption)caption.textContent=finish.value==='personalizado'?'Un punto de partida · Inspiración':finish.selectedOptions[0].textContent+' · Inspiración';
      update();
    };
    if(finish){finish.addEventListener('change',refreshImage);refreshImage();}
  });
  const dialog=document.querySelector('[data-tf-dialog]');
  if(dialog&&typeof dialog.showModal==='function'){
    document.querySelectorAll('[data-tf-product]').forEach(link=>link.addEventListener('click',event=>{
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();
      const image=link.querySelector('img');const target=dialog.querySelector('[data-tf-dialog-image]');
      target.src=image.src;target.alt=image.alt;
      dialog.querySelector('[data-tf-dialog-title]').textContent=link.querySelector('h3').textContent;
      dialog.querySelector('[data-tf-dialog-copy]').textContent=link.querySelector('p').textContent;
      dialog.querySelector('[data-tf-dialog-cta]').href=link.href;
      dialog.showModal();
    }));
    dialog.querySelector('.tf-dialog-close').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
  }
  document.querySelectorAll('[data-tf-preview-form]').forEach(form=>form.addEventListener('submit',event=>{
    event.preventDefault();
    const message=form.querySelector('[data-tf-preview-message]');
    message.textContent='Comprobación local completada. En Shopify esta solicitud se enviará al correo de la tienda. Aquí no se ha enviado ni guardado ningún dato.';
    message.hidden=false;message.focus();
  }));
})();
